module.exports = __webpack_public_path__ + "img/frozen_baby_corn.12b1140c.jpg";